import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import $ from 'jquery';
import './CodigoForms.css'; // Importando o CSS do Código Validador
const CodigoForms = forwardRef((props, ref) => {
    const [cod1, setCod1] = useState();
    const [cod2, setCod2] = useState();
    const [codigoAtivador, setCodigoAtivador] = useState('');
    const [codigoAtivadorValido, setCodigoAtivadorValido] = useState(false);

    useImperativeHandle(ref, () => ({
        gerarNovoCodigo
    }));

    useEffect(() => {           
            gerarNovoCodigo();
    }, []);

    const gerarNovoCodigo = () => {
        setCod1(Math.floor(Math.random() * 10) + 1);
        setCod2(Math.floor(Math.random() * 10) + 1);
        $("#codigoAtivador").val("");
        $("#codigoAtivadorValido").val("false");
    }
    
    const handleCodigoAtivadorChange = (e) => {
        const valor = e.target.value;
        setCodigoAtivador(valor);
        console.log(parseInt(valor) === (parseInt(cod1) + parseInt(cod2)), parseInt(cod1), parseInt(cod2));        
        // Aqui você pode adicionar a lógica para validar o código de ativação
        // Por exemplo, se o código for "1234", considere-o válido
        if (parseInt(valor) === (parseInt(cod1) + parseInt(cod2))) {
            setCodigoAtivadorValido(true);
        } else {
            setCodigoAtivadorValido(false);
        }
    }

    return (
        <div className="form-group">
            <label id="lblcodigoAtivador" htmlFor="codigoAtivador">Quanto é {cod1} + {cod2}?</label>
            <input type="text" className="form-control" id="codigoAtivador" onChange={handleCodigoAtivadorChange} placeholder="Digite o código de ativação" />
            <input type="hidden" id="codigoAtivadorValido" value={codigoAtivadorValido} />
        </div>
    );
});
export default CodigoForms;